import React from 'react';
import VstComponent from './VstComponent';
import PropTypes from 'prop-types';
import colors from '../style/js-colors';

class VstLoader extends VstComponent {

  constructor(props) {
    super();
    this.state = { hidden: props.delay };
  }

  svgLoader() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
        <path fill={colors.CLOUD[4]} d="M26 4c12.1 0 22 9.9 22 22s-9.9 22-22 22S4 38.1 4 26 13.9 4 26 4m0-4C11.6 0 0 11.6 0 26s11.6 26 26 26 26-11.6 26-26S40.4 0 26 0z" opacity=".8" />
        <path fill={this._theme(7)} d="M26 0v4c12.1 0 22 9.9 22 22s-9.9 22-22 22v4c14.4 0 26-11.6 26-26S40.4 0 26 0z" />
      </svg>
    );
  }

  componentDidMount() {
    if (this.props.delay) {
      this.delayTimeout = setTimeout(() => {
        this.setState({ hidden: false });
      }, this.props.delay);
    }
  }

  componentWillUnmount() {
    if (this.delayTimeout) {
      clearTimeout(this.delayTimeout);
    }
  }

  render() {
    if (!this.state.hidden) {
      return (
        <div className="vst-loader-container">
          <div>
            <span className="loader">{this.svgLoader()}</span>
          </div>
          <span>{this.props.children}</span>
        </div>
      );
    }
    return <span />;
  }

}

VstLoader.propTypes = {
  accent: PropTypes.bool,
  delay: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
  ]),
};

VstLoader.defaultProps = {
  accent: true,
  delay: false,
};

export default VstLoader;
